import { render } from "./ResultEmpty.vue?vue&type=template&id=7da073b2&scoped=true"
import script from "./ResultEmpty.vue?vue&type=script&lang=js"
export * from "./ResultEmpty.vue?vue&type=script&lang=js"

import "./ResultEmpty.vue?vue&type=style&index=0&id=7da073b2&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da073b2"]])

export default __exports__